import { render } from "./HistorialVentas.vue?vue&type=template&id=5d99eebe&scoped=true"
import script from "./HistorialVentas.vue?vue&type=script&lang=js"
export * from "./HistorialVentas.vue?vue&type=script&lang=js"

import "./HistorialVentas.vue?vue&type=style&index=0&id=5d99eebe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d99eebe"]])

export default __exports__